const RequestsIndex = () => import('@/views/Dashboard/Requests/RequestsIndex');
const RequestsList = () => import('@/views/Dashboard/Requests/RequestsList');

export default {
  path: '/requests',
  component: RequestsIndex,
  children: [
    {
      path: '/',
      name: 'requests',
      component: RequestsList,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
  ],
};
